import FormResult from 'components/Form/FormResult';
import InputText from 'components/Form/InputText';
import Layout from 'components/Layout';
import Modal from 'components/Modal';
import {FC} from 'react';
import {FormProvider, useForm} from 'react-hook-form';
import {useBackend} from 'state/backend';
import {t} from 'ttag';
import {FormFields} from 'types/utils';
import {onApiError} from 'utils/request-axios/utils';
import {onApiKeySuccess} from 'utils/request/result';

import {useRenameTag} from '../services';
import {Tag} from '../types';

type FormData = FormFields<{name: string; renameTo: string}>;

type RenameTagModalProps = {isOpen: boolean; onClose: () => void; tag: Tag};

const RenameTagModal: FC<RenameTagModalProps> = ({isOpen, onClose, tag}) => {
    const {refreshData} = useBackend();
    const renameTag = useRenameTag();
    const methods = useForm<FormData>({defaultValues: {renameTo: tag.name}});
    const {handleSubmit} = methods;

    const submit = ({renameTo}: FormData) => {
        const formData = {name: tag.name, rename_to: renameTo};
        renameTag
            .mutateAsync({formData, id: tag.id})
            .then(() => {
                onApiKeySuccess(methods);
                onClose();
                refreshData(window.Urls.partner_tags_view());
            })
            .catch(onApiError(methods));
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} preventOutsideClick={false}>
            <FormProvider {...methods}>
                <Modal.Header>{t`Rename Tag`}</Modal.Header>
                <Modal.Body>
                    <Layout.Stacked className="mt-6">
                        <InputText
                            // eslint-disable-next-line jsx-a11y/no-autofocus
                            autoFocus={true}
                            label={t`Tag name`}
                            maxLength={100}
                            name="renameTo"
                            required={true}
                        />
                    </Layout.Stacked>
                    <FormResult />
                </Modal.Body>
                <Modal.Footer>
                    <Modal.Button
                        kind="secondary"
                        onClick={onClose}
                        size="sm"
                        type="cancel"
                    >
                        {t`Cancel`}
                    </Modal.Button>
                    <Modal.Button
                        className="ml-2"
                        isLoading={renameTag.isPending}
                        kind="primary"
                        onClick={handleSubmit((formData) => {
                            submit(formData);
                        })}
                        size="sm"
                        type="submit"
                    >
                        {t`Save`}
                    </Modal.Button>
                </Modal.Footer>
            </FormProvider>
        </Modal>
    );
};

export default RenameTagModal;
